import React from "react";
import { Component } from "react";

import { Container, Card } from "react-bootstrap";

class Footer extends Component {
    render() {
        return (
        <div>
            <Container>
    <Card>
        <Card.Body>
       
        <Card.Title><p>oddkin | unfinished_configurations</p></Card.Title>
       <Card.Text>
        <p>This app leverages the captivating beauty of jellyfish and the potential of bioluminescence to create a synthetic counterpoint with Haraway's text. Drawing on the ideas and themes from "Staying with the Trouble" by Donna Haraway, the app encourages users to explore the complex and mixed-up times we live in and consider our relationship with the natural world and what we consider artificial or synthetic.

The app chains calls to both the Davinci model and Dall-e to generate prompts, questions and images  inspired by Haraway's text and my strange dreams with biolumiscent jellyfish in the depths of earth oceans. The models are used in chain unfinished_configurations in order to generate infinite black and white images of jellyfish that highlight their natural beauty, synthetic provenance, ephemeratily and awe.

Through this combination of synthetic media and the interplay of text and visuals, the app encourages users to engage with complex and challenging ideas about nature and culture in a new and innovative way. By highlighting the natural beauty of jellyfish, the evocative potential of bioluminescence and its synthetic generation,  the app encourages us to see the urgency and the beauty simultaneously. By exploring these ideas through the lens of Haraway's text, the app encourages us to reflect on our own relationship with the natural world and consider how we can respond to the challenges when facing alien entities such as jellyfish and perhaps AI models. They are beatiful and ephemeral oddkins.</p>
        
       
<p>Concept and programming by <a target="_blank" rel="noreferrer" href="https://marlonbarrios.github.io/">Marlon Barrios Solano</a></p>
<p><a target="_blank" rel="noreferrer" href="https://www.patreon.com/user?u=84024387">Support R&D and help with the costs of OpenAI</a></p>
<p>Powered by <a target="_blank" rel="noreferrer" href=" https://beta.openai.com/overview">OpenAI</a></p>
            </Card.Text>
        </Card.Body>
    </Card>
</Container>
        </div>
        );
    }
    }
export default Footer;
